<template>
  <section class="section section4">
    <div class="section-wrap">
      <div class="s4-top-box">
        <h2 class="s4-title">{{$t('home.s4_1')}}</h2>
        <p class="s4-ps">{{$t('home.s4_2')}}</p>
        <div @click="routerSkip('/program')" class="realize-more clearfix">{{$t('common.more')}} <img src="@/assets/images/icon/more-point-right-p.png"></div>
      </div>
      <div class="s4-bottom-box s4-product-wrap clearfix">

        <div class="s4-wrap-top"  @click="routerSkip('/program/list',item.type)" v-for="(item,index) in list" :key="index">
          <div class="s4-wrap-top-img" :style="{'background-image': 'url('+ item.img +')'}"></div>
          <div class="s4-wrap-text tc"><span>{{ item.title }}</span></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'pageHome',
    data () {
      return {
        list:[]
      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {
        let list = []
        for(let i = 1; i <= 8; i++){
          list.push({
            title:this.$t('home.s4_0'+i),
            img:require('@/assets/images/mockImg/p-s4-'+i+'.png'),
            type:(i<= 4? 1 : (i>4 && i <8 ) ? 2 : 3)
          })
        }
        this.list = list
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .section4
    padding-bottom 1.35rem;background-image url("~@/assets/images/home/4-bg.png");bgCover()
    .s4-top-box
      rela();width 100%;padding .65rem 0;
      .s4-title
        font-size .36rem;font-weight normal;color $standardColor
      .s4-ps
        margin-top .08rem;font-size .14rem;color #333333
      .realize-more
        abso();right 0;bottom .68rem;width: 1.05rem;height: .36rem;border-bottom .02rem solid #666666;line-height .34rem;color #666666;cursor pointer
        img
          fr();margin-top .08rem;width: .24rem;height: .16rem;
    .s4-bottom-box.s4-product-wrap
      width: 100%
      .s4-wrap-top
        margin-right:.1rem;fl();width:calc(100%/4 - 0.1rem);margin-bottom:.1rem
        &:nth-child(4n){margin-right:0}
        .s4-wrap-top-img
          height: 4.1rem;width:100%;
        .s4-wrap-text
          width: 100%;padding 0 .14rem;font-size .16rem;color #fff;background-color:#004098;
          span{
            display: table-cell;width:3rem;vertical-align:middle;tc();height: .34rem;line-height:1
          }

      
</style>
